import { MDBCheckbox, MDBInput } from "mdb-react-ui-kit";
import { useCallback } from "react";
import { ASParamEditorProps } from "../ASParamEditor";

export const AS8YNParam = ({currentValue, realValue, disabled, param, onCurrentValueChange}: ASParamEditorProps<number>) => {

    const onCheck = useCallback((idx: number, check: boolean) => {
        if (currentValue == null) return;
        onCurrentValueChange(check ? (currentValue | (1 << idx)) : (currentValue & (~(1 << idx))));
    }, [currentValue, onCurrentValueChange]);

    return (
        <div className="d-flex flex-column justify-content-start text-start ps-2">
            {Array.from(new Array(8)).map((_, idx) => (
                <MDBCheckbox
                    key={param.addr+String(idx)}
                    className=""
                    type="checkbox"
                    checked={currentValue!==null && Boolean(((currentValue & (1 << idx))))}
                    disabled={disabled}
                    onChange={ev => onCheck(idx, ev.currentTarget.checked)}
                    label={(param.items ?? [])[idx] ?? "???"}
                    labelStyle={{lineHeight: 1.4}}
                />
            ))}
        </div>
        
    )
}